import * as types from '../const/action.types';
import initialStates from '../store/initial.state';

export default function sessionReducer(state = initialStates.locales, action) {
    switch (action.type) {
        case types.SET_LANG:
            if (state.languages[action.lang] === undefined) return state;
            sessionStorage.setItem('iflares_language', action.lang);
            console.log('iflares_language', action.lang);
            window.location.reload();
            return {
                lang: action.lang,
                messages: state.languages[action.lang],
                languages: state.languages,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/language.reducer.js